<template>
  <section
    v-editable="blok"
    class="col-span-full"
    :style="{
      gridRowStart: rowStartClass,
    }"
  >
    <AgsLazy
      v-for="content in blok.content"
      :key="content._uid"
      :important="!isMobile && Number(rowStartClass) < 4"
      placeholder-ratio="16/9"
    >
      <component :is="content.component" :blok="content" :category="category" />
    </AgsLazy>
  </section>
</template>

<script lang="ts">
import type { SbListingDisruptor } from '~/cms/storyblok/types/storyblok.d.ts'
import { useDeviceType } from '~/composables/useDeviceType'

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<SbListingDisruptor>,
      default: () => {},
    },
    category: {
      type: String,
      default: undefined,
    },
  },
  setup({ blok }) {
    const { isMobile } = useDeviceType()
    return {
      isMobile,
      rowStartClass: computed(() =>
        blok?.insert_in_row ? blok?.insert_in_row : 4,
      ),
    }
  },
})
</script>
